/**
 * Lightweight in-memory page cache for stale-while-revalidate loading.
 *
 * Data lives for the lifetime of the SPA session (cleared on a full page
 * reload), so navigating away from a page and back shows the last-known data
 * instantly while a fresh fetch runs in the background.
 *
 * Keys should be namespaced and tenant-scoped, e.g. `activities:<tenantId>`.
 */
const store = new Map();

export const getPageCache = (key) => (key ? store.get(key) : undefined);

export const setPageCache = (key, value) => {
    if (key) store.set(key, value);
};

export const hasPageCache = (key) => (key ? store.has(key) : false);

export const clearPageCache = (key) => {
    if (key) store.delete(key);
    else store.clear();
};
